<template>
  <div>
    <article v-if="article">
      <h1>{{ article.title }}</h1>
      <time :datetime="article.date">{{ article.date | timeFilter }}</time>
      <p v-html="article.abstract" class="text-left"></p>
    </article>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      id: "",
      article: null
    };
  },
  computed: {
    ...mapState(["articles"])
  },
  methods: {},
  mounted() {
    this.id = this.$route.params.id;
    this.article = this.articles.find(item => item.id === this.id);
  },
};
</script>

<style lang="scss" scoped>
article {
  display: flex;
  flex-direction: column;
  padding: 4rem 3rem;
  i {
    margin-top: 1rem;
  }
  span {
    margin-top: 2rem;
    text-align: left;
  }
}
</style>